import { Injectable, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ExitType } from '@core/guards/exit-interface';

@Injectable({
    providedIn: 'root'
})
export class ExitGuardService {
    private modals: {[key: string]: TemplateRef<any>} = {};
    public skipGuard = false;

    constructor(private modal: NgbModal) {}

    registerTemplate(exitType: ExitType, template: TemplateRef<any>) {
        this.modals[exitType] = template;
    }

    has(exitType: ExitType): boolean {
        return this.modals[exitType] !== undefined;
    }

    async open(exitType: ExitType): Promise<boolean> {
        const modalRef = this.modal.open(this.modals[exitType], {
            backdrop: 'static',
            keyboard: false,
            centered: true,
        });

        return modalRef.result
            .then(() => true)
            .catch(() => false);
    }

    bypassGuard() {
        this.skipGuard = true;
    }

    resetGuard() {
        this.skipGuard = false;
    }
}
